// extracted by mini-css-extract-plugin
export var leftAlign = "_20-2";
export var popper = "_20-0";
export var subtitle = "_20-1";